import { useForm } from "react-hook-form";
import {
  Button,
  CloseButton,
  FormGroup,
  Input,
  Label,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
  StatusSelect,
  UploadBox,
  UploadInput,
  UploadPreview,
} from "../../../style/admin/BlogCreateModal_Style";
import QuillEditor from "../../../components/QuillEditor";
import { Box } from "@mui/material";
import { EBlogResponse } from "../../../models/blog";
import { useEffect, useState } from "react";
import UploadFileService from "../../../services/api/uploadFile.service";
import { toast } from "../../../utils/notify";
import BlogService from "../../../services/api/blog.service";
import { jwtDecode } from "jwt-decode";
import { ITokenPayload } from "../../../models/user";
import { envConfig } from "../../../config/env.config";
import { IBaseResponseModel } from "../../../models/common/models.type";
import { EContentResponse } from "../../../models/seo";
import { DocumentNoteHeader } from "../../../AdminLayout_Style";
import { useNavigate } from "react-router-dom";
import { forwardRef, useImperativeHandle } from "react";
import { EPageResponse } from "../../../models/page";
import PageService from "../../../services/api/page.service";

interface PageDetailProps {
  page: EPageResponse | null;
  objId: string | null;
}
interface PageDetailRef {
  validate: () => Promise<boolean>;
  submit: () => Promise<void>;
}

const PageDetail = forwardRef<PageDetailRef, PageDetailProps>(
  ({ page, objId }, ref) => {
    const {
      register,
      setValue,
      watch,
      reset,
      trigger,
      handleSubmit,

      formState: { errors },
    } = useForm<EPageResponse>({
      defaultValues: {
        name: "",
        url: "",
      },
    });

    const [preview, setPreview] = useState<string | null>(null);
    const [user, setUser] = useState<ITokenPayload | null>();
    const navigate = useNavigate();

    useEffect(() => {
      const token = localStorage.getItem("token");

      if (token) {
        const user = jwtDecode<ITokenPayload>(token);
        user && setUser(user);
      }
    }, []);

    useEffect(() => {
      if (page) {
        setValue("id", page.id);
        setValue("title", page.title);
        setValue("name", page.name);
        setValue("url", page.url);
      }
    }, [page]);

    const onSubmit = async (data: EPageResponse) => {
      const res = await PageService.update(data);

      if (res.success) {
      } else {
        toast(res.message, "error");
      }
    };

    const submitForm = handleSubmit(onSubmit);

    useImperativeHandle(ref, () => ({
      submit: handleSubmit(onSubmit),
      validate: async () => {
        const isValid = await trigger();

        if (!isValid) {
          toast("Vui lòng kiểm tra lại dữ liệu page", "info");
        }

        return isValid;
      },
    }));

    return (
      <>
        <DocumentNoteHeader>
          <h3>Nhập page</h3>
          {/* <button onClick={() => handleOpenModal()}>+ Thêm Blog</button> */}
        </DocumentNoteHeader>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Box>
            <FormGroup>
              <FormGroup>
                <Label>Tên page</Label>
                <Input
                  disabled
                  {...register("name", {
                    required: "Tên page không được để trống",
                  })}
                />
                {errors.url && (
                  <span style={{ color: "#e53935", fontSize: 13 }}>
                    {errors.url.message}
                  </span>
                )}
              </FormGroup>

              <Label>Tiêu đề</Label>
              <Input
                {...register("title", {
                  required: "Tiêu đề không được để trống",
                })}
              />
              {errors.name && (
                <span style={{ color: "#e53935", fontSize: 13 }}>
                  {errors.name.message}
                </span>
              )}
            </FormGroup>

            <FormGroup>
              <Label>Url</Label>
              <Input
                disabled
                {...register("url", {
                  required: "url không được để trống",
                })}
              />
              {errors.url && (
                <span style={{ color: "#e53935", fontSize: 13 }}>
                  {errors.url.message}
                </span>
              )}
            </FormGroup>
          </Box>
        </form>
      </>
    );
  },
);

export default PageDetail;
